module.exports = __webpack_public_path__ + "img/denmark-neoplasm-male.c73b2545.png";